<template>
<div>
    <az-toolbar id="toolbar-requisicoes" class="d-inline-flex">
        <span slot="actions">
            <az-back-button class="ma-0 pb-4" slot="actions" :route="{name: 'InformacoesSistema'}" text="Voltar para integrações"/>
        </span>
        <az-search slot="simpleSearch" :filter="filtrosInterno"
                   @simple-search="tratarEventoBuscaSimples"
                   @remove-filter="tratarEventoRemoverFiltro"
                   :simple-search-placeholder="placeholderPesquisa"/>
    </az-toolbar>

    <requisicoes-com-erro-carrossel v-if="requisicoesComErro.length > 0"
            class="mt-2 mb-0 pb-0"
            id="requisicoes-erro-carrossel"
            :key="componentKey"
            :requisicoesComErro.sync="requisicoesComErro"
            :baseUrl="baseUrlSistema"
            :exibirLimparSelecao="exibirListagemErro"
            :exibirSelecionarTodos="!exibirListagemErro"
            @limparSelecao="limparSelecao()"
            @selecionarTodos="selecionarTodos()"
            @marcarCard="adicionarSelecaoCard"
            @desmarcarCard="removerSelecaoCard"
            @refresh="buscarRequisicoesComErro"
    />

    <fila-requisicoes-tabela class="mb-4 mt-0 pt-0"
                             id="tabela-requisicoes"
                             :itens="requisicoesListagem"
                             :paginas="exibirListagemErro? requisicoesErroPaginas : paginas"
                             :total-itens="exibirListagemErro? requisicoesErroTotalItens : totalItens"
                             :baseUrl="baseUrlSistema"
                             :paginacao="definirPaginacao"
                             :sistemaIntegracao="sistemaIntegracao"
                             :exibirComandos="!exibirListagemErro"
                             @atualizar="atualizarRequisicao"
                             @refresh="buscarTodasRequisicoesPorSistema"
                             @paginar="tratarEventoPaginar"
                             @removerRequisicaoPNCP="removerRequisicaoPNCP"
    />


</div>
</template>
<script>
import {actionTypes, mutationTypes} from '@/core/constants'
import FilaRequisicoesTabela from './FilaRequisicoesTabela'
import RequisicoesComErroCarrossel from './RequisicoesComErroCarrossel'
import _ from 'lodash'

export default{
    name: 'FilaRequisicoes',
    components: {RequisicoesComErroCarrossel, FilaRequisicoesTabela},
    data(){
        return{
            menuAnteriorRetraido: false,
            filtrosInterno: this.getFiltrosRequisicoes(),
            sistemaIntegracao: null,
            paginas: null,
            totalItens: null,
            requisicoes:[],
            requisicoesSelecionadasIds:[],
            baseUrlSistema: null,
            componentKey: 0,
            requisicoesComErro: [],
            requisicoesErroPaginas: null,
            requisicoesErroTotalItens: null,
        }
    },
    async mounted() {
        this.fecharMenuLateral()
        this.sistemaIntegracao = this.$route.params.sistema
        await this.buscarTodasRequisicoesPorSistema()
        await this.buscarRequisicoesComErro()
    },
    computed:{
        placeholderPesquisa() {
            return 'Busque por: nº processo, situacao, url, etc...'
        },
        exibirListagemErro(){
            return this.requisicoesSelecionadasIds.length > 0
        },
        requisicoesListagem(){
            if(this.exibirListagemErro){
                return this.requisicoesComErro.filter((item) => this.requisicoesSelecionadasIds.includes(item.id))
            }
            return this.requisicoes
        },
        definirPaginacao(){
            if(this.exibirListagemErro){
                return this.$store.state.comprador.filaRequisicoesComErro.paginacao
            }
            return this.$store.state.comprador.filaRequisicoes.paginacao
        }
    },
    methods:{
        fecharMenuLateral(){
            this.menuAnteriorRetraido = this.$store.state.loki.asideClosed
            this.$store.state.loki.asideClosed = true
        },
        async buscarRequisicoesComErro(){
            this.setMensagemLoading('Carregando requisições com erro...')
            const resultado = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_REQUISICOES_COM_ERRO_POR_SISTEMA, this.sistemaIntegracao)
            this.requisicoesComErro = resultado.itemList
            this.requisicoesErroPaginas = resultado.totalPages
            this.requisicoesErroTotalItens = resultado.totalElements
        },
        async buscarTodasRequisicoesPorSistema(){
            this.$store.commit(mutationTypes.COMPRADOR.SET_FILTROS_BUSCA_REQUISICOES_POR_SISTEMA, this.getFiltrosInterno())
            this.setMensagemLoading('Carregando requisições...')
            const resultado = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_REQUISICOES_POR_SISTEMA, this.sistemaIntegracao)
            this.requisicoes = resultado.itemList
            this.paginas = resultado.totalPages
            this.totalItens = resultado.totalElements
            this.baseUrlSistema = resultado.baseUrlSistema
        },
        async atualizarRequisicao(requisicao){
            this.setMensagemLoading('Atualizando requisição...')
            await this.$store.dispatch(actionTypes.COMPRADOR.ATUALIZAR_REQUISICAO_HTTP, requisicao)
            await this.buscarRequisicoesComErro()
        },
        tratarEventoBuscaSimples(valor) {
            if (valor) {
                this.filtrosInterno.objeto.value = valor
                this.filtrosInterno.conteudo = valor
                this.buscarTodasRequisicoesPorSistema()
            }
        },
        tratarEventoPaginar(paginacao) {
            this.$store.commit(mutationTypes.COMPRADOR.SET_PAGINACAO_BUSCA_REQUISICOES_POR_SISTEMA, paginacao)
            this.buscarTodasRequisicoesPorSistema()
        },
        tratarEventoRemoverFiltro(propriedade) {
            if (this.filtrosInterno && this.filtrosInterno.hasOwnProperty(propriedade)) {
                this.filtrosInterno[propriedade].value = this.filtrosInterno[propriedade].default
            }
            this.filtrosInterno.conteudo = ''
            this.buscarTodasRequisicoesPorSistema()
        },
        getFiltrosRequisicoes() {
            return _.cloneDeep(this.$store.state.comprador.filaRequisicoes.filtros)
        },
        getFiltrosInterno() {
            return _.cloneDeep(this.filtrosInterno)
        },
        adicionarSelecaoCard(requisicao){
            this.requisicoesSelecionadasIds.push(requisicao.id)
        },
        removerSelecaoCard(requisicao){
            const index = this.requisicoesSelecionadasIds.indexOf(requisicao.id)
            if (index > -1) {
                this.requisicoesSelecionadasIds.splice(index, 1)
            }
        },
        limparSelecao(){
            this.requisicoesSelecionadasIds = []
        },
        selecionarTodos(){
            this.requisicoesSelecionadasIds = this.requisicoesComErro.map(requisicao => {return requisicao.id})
        },
        async removerRequisicaoPNCP(requestData) {
            this.setMensagemLoading('Removendo requisição...')
            await this.$store.dispatch(actionTypes.COMPRADOR.REMOVER_REQUISICAO_COM_ERRO, requestData)
            await this.buscarRequisicoesComErro()
            await this.buscarTodasRequisicoesPorSistema()
        }
    },
    beforeDestroy(){
        this.$store.state.loki.asideClosed = this.menuAnteriorRetraido
    },
    watch:{
        'requisicoesComErro':{
            handler(novoValor){
                this.componentKey += 1
                this.requisicoesSelecionadasIds.forEach((id, index) => {
                    let indiceEncontrar = novoValor.findIndex(item => {return item.id === id})
                    if(indiceEncontrar === -1){
                        this.requisicoesSelecionadasIds.splice(index, 1)
                    }
                })
            },
            deep:true
        }
    }
}
</script>
